module.exports = __webpack_public_path__ + "static/media/card-gift-bg.92b66298.png";